import { useAtomValue } from 'jotai';
import { isLoginAtom } from '@/store';

/**
 * 用于判断用户是否登录的 Hook
 * 
 * @returns isLogin - 用户是否已登录
 * 
 * @example
 * ```tsx
 * const { isLogin } = useIsLogin();
 * 
 * if (!isLogin) {
 *   return <LoginPrompt />;
 * }
 * ```
 */
export default function useIsLogin() {
  const isLogin = useAtomValue(isLoginAtom);

  return {
    isLogin,
  };
}

